import { render, staticRenderFns } from "./GroupBookingCreateInvoice.vue?vue&type=template&id=5990f8e8&"
import script from "./GroupBookingCreateInvoice.vue?vue&type=script&lang=js&"
export * from "./GroupBookingCreateInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports